module.exports = __webpack_public_path__ + "assets/img/service5.5d61d06b.png";